// extracted by mini-css-extract-plugin
module.exports = {"section":"section--CobU22yF","skeleton":"skeleton--xyAaxiH3","shimmer":"shimmer--fIGxJAXN"};